let lastScrollPosition = 0;

/**
 * Returns the current scroll position
 */
export const currentScrollPosition = () =>
  document.body.scrollTop || document.documentElement.scrollTop;

/**
 * @param {Number} y Will get the current scroll position as default.
 */
export const isScrollingDown = (y = currentScrollPosition()) =>
  y > lastScrollPosition;

/**
 *
 * @param {Number} y Will get the current scroll position as default.
 */
export const isScrollingUp = (y = currentScrollPosition()) =>
  y < lastScrollPosition;

/**
 * Returns the current scroll direction as a string.
 * @returns {String} 'down' or 'up'
 */
export const scrollDirection = () => (isScrollingDown() ? 'down' : 'up');

/**
 * Sets the last scrollPosition
 * @param {Number} y Will get the current scroll position as default.
 * @returns {Number} The new last scroll position.
 */
export const setLastScrollPosition = (y = currentScrollPosition()) => {
  lastScrollPosition = y;
  return lastScrollPosition;
};
